export const PHONE_CALL_STATUS = {
  READY: 'Ready',
  INPROGRESS: 'In progress',
  CONNECTING: 'Connecting',
  CONNECTED: 'Connected',
  OFFLINE: 'Offline',
} as const

export type PhoneCallStatus = (typeof PHONE_CALL_STATUS)[keyof typeof PHONE_CALL_STATUS]
